<template>
  <centered-layout :white="true" :horizontal="true">
    <div class="text-center">
      <h1 class="heading heading--h3">Oops. Something went wrong.</h1>
      <h2 class="heading heading--h5"><span class="heading heading-h2">404</span> - Page not found.</h2>
    </div>
  </centered-layout>
</template>

<script>
import CenteredLayout from '@/components/UI/CenteredLayout.vue';

export default {
  name: 'PageNotFound',
  components: {
    CenteredLayout,
  },
};
</script>
